class HeaderNav extends HTMLElement {
  constructor() {
    super();
    this.CLASS_ACTIVE = 'active';
    this.init();
  }

  init() {
    this.toggleNav();
  }

  toggleNav() {
    const iconMenu = document.querySelector('.header-icon-menu');
    const closeButton = this.querySelector('.pd-close-button');
    const navLinks = this.querySelectorAll('.header-nav-link.expandable');
    const overlay = document.querySelector('.main-header .overlay');

    iconMenu.addEventListener('click', () => {
      this.classList.add(this.CLASS_ACTIVE);
      document.documentElement.classList.add('prevent-scroll');
      document.body.classList.add('prevent-scroll');
    })

    closeButton.addEventListener('click', () => {
      this.classList.remove(this.CLASS_ACTIVE);
      overlay.classList.remove(this.CLASS_ACTIVE);
      document.documentElement.classList.remove('prevent-scroll');
      document.body.classList.remove('prevent-scroll');
    })

    navLinks.forEach(navLink => {
      navLink.addEventListener('click', (e) => {
        e.preventDefault();
        const childList = navLink.nextElementSibling;
        if (navLink.classList.value.search(this.CLASS_ACTIVE) > -1) {
          navLink.classList.remove(this.CLASS_ACTIVE);
          childList.classList.remove(this.CLASS_ACTIVE);
        } else {
          navLink.classList.add(this.CLASS_ACTIVE);
          childList.classList.add(this.CLASS_ACTIVE);
        }
      })
    })
  }
}

customElements.define('header-nav', HeaderNav);